import { useEffect } from "react";
import keyboardInset from "@/hooks/keyboardInset";

const scrollParent = (el) => {
  for (let n = el.parentElement; n; n = n.parentElement) {
    const oy = getComputedStyle(n).overflowY;
    if ((oy === "auto" || oy === "scroll") && n.scrollHeight > n.clientHeight) return n;
  }
  return null;
};

/** Phones: when any text box on a page is tapped, slide it to sit just above the keyboard. */
export default function KeyboardDock() {
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return undefined;
    let timer = 0;
    const dock = (el) => {
      if (window.innerWidth >= 640 || !el?.isConnected || document.activeElement !== el) return;
      if (el.closest("[role='dialog'], [data-testid='chat-composer'], [data-no-keyboard-dock]")) return;
      if (keyboardInset() < 80) return; // keyboard not up
      const r = el.getBoundingClientRect();
      const keyTop = vv.offsetTop + vv.height;
      const delta = r.bottom - (keyTop - 12);
      if (Math.abs(delta) < 6 || (delta < 0 && r.top > vv.offsetTop + vv.height * 0.35)) return;
      const box = scrollParent(el);
      if (box) box.scrollBy({ top: delta, behavior: "smooth" });
      else window.scrollBy({ top: delta, behavior: "smooth" });
    };
    const onFocus = (e) => {
      if (!e.target.matches?.("input:not([type=checkbox]):not([type=radio]):not([type=file]):not([type=range]), textarea, [contenteditable='true']")) return;
      clearTimeout(timer);
      timer = setTimeout(() => dock(e.target), 350);
    };
    const onResize = () => { const el = document.activeElement; if (el && el !== document.body) { clearTimeout(timer); timer = setTimeout(() => dock(el), 120); } };
    window.addEventListener("focusin", onFocus);
    vv.addEventListener("resize", onResize);
    return () => { clearTimeout(timer); window.removeEventListener("focusin", onFocus); vv.removeEventListener("resize", onResize); };
  }, []);
  return null;
}
